export const CAPABILITIES = {
  DASHBOARD_VIEW: 'dashboard.view',
  TRANSACTIONS_VIEW: 'transactions.view',
  TRANSACTIONS_DETAILS_VIEW: 'transactions.details.view',
  TRANSACTIONS_STATUS_VIEW: 'transactions.status.view',
  POLICY_RULES_VIEW: 'policy.rules.view',
  POLICY_RULES_MANAGE: 'policy.rules.manage',
  ADMIN_PLANS_VIEW: 'admin.plans.view',
  ADMIN_PLANS_MANAGE: 'admin.plans.manage',
  TENANCY_VIEW: 'tenancy.view',
  TENANCY_ORGANIZATIONS_MANAGE: 'tenancy.organizations.manage',
  TENANCY_CLIENTS_MANAGE: 'tenancy.clients.manage',
  USERS_VIEW: 'users.read',
  USERS_CREATE: 'users.create',
  USERS_UPDATE: 'users.update',
};
